import * as React from 'react';
import { CardAvatarContainer } from '../CardAvatarContainer';
import { RealtorCard } from '../../components/RealtorCard';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';

export interface IListOfRealtorsContainerProps {
  realtors: ISpecialistCatalogListingSchema[];
  selectedRealtorsId: number[];
  selectRealtor: (id: ISpecialistCatalogListingSchema) => void;
  unselectRealtor: (id: string) => void;
  onRealtorClick: (id: ISpecialistCatalogListingSchema) => void;
  isButtonDisabled: boolean;
}

export const ListOfRealtorsContainer: React.FC<React.PropsWithChildren<IListOfRealtorsContainerProps>> = props => {
  const { realtors, onRealtorClick, selectRealtor, unselectRealtor, selectedRealtorsId, isButtonDisabled } = props;

  return (
    <>
      {realtors.map(realtor => {
        const {
          id,
          timeOnSite,
          agencyName,
          fullName,
          reviewsRate,
          reviewsCount,
          trustLevelName,
          trustLevel,
          avatarUrl,
        } = realtor;

        return (
          <RealtorCard
            key={id}
            onClick={() => onRealtorClick(realtor)}
            previewImg={<CardAvatarContainer imgUrl={avatarUrl} fullName={fullName} isCircleImage={true} />}
            agentId={id}
            timeOnSite={timeOnSite}
            agencyName={agencyName}
            hasRgrParticipation={false}
            name={fullName}
            rate={reviewsRate}
            reviewsCount={reviewsCount}
            levelName={trustLevelName}
            levelNumber={trustLevel}
            selectRealtor={() => selectRealtor(realtor)}
            unselectRealtor={() => unselectRealtor(String(id))}
            isSelected={selectedRealtorsId.includes(id)}
            disabledButton={isButtonDisabled}
          />
        );
      })}
    </>
  );
};

ListOfRealtorsContainer.displayName = 'ListOfRealtorsContainer';
